import module from './audience-manager';
export default module;